module.exports = [{"name":"login","endpoints":{"production":"https://accounts.rdstation.com.br"}}]